export default __webpack_public_path__ + "cb3c725c1fcb9ac1bccebf7a213bd22e.svg";